var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',{staticStyle:{"margin":"16px 0"}},_vm._l((_vm.breadcrumb),function(item){return _c('a-breadcrumb-item',{key:item.key},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }